import { globalProps } from "neetocommons/v2/initializers";

export const NEETO_KB_ENDPOINT = globalProps?.kbUrl;
export const NEETO_KB_ARTICLES_URL = "/api/v1/articles";
export const NEETO_KB_CATEGORIES_URL = "/api/v1/categories";

export const MODE = { MODAL: "modal", SELECT: "select" };

export const MODAL_BOTTOM_MARGIN = 50;
export const MODAL_LEFT_OFFSET = 50;
export const MODAL_TOP_OFFSET = 22;
export const MODAL_TRANSFORM_Y = 52;
export const MODAL_TRANSFORM_X = 8;
